import { SCHCTemplateFormatI } from '.';

import { SCHCTemplateRuleEntryValidFieldNames } from 'shared/models/schc-templates';
import SCHCTemplate from 'shared/models/SCHCTemplate';

class SCHCTemplateFormatAPIToForm implements SCHCTemplateFormatI<
  SCHCTemplate.API.BodyT,
  SCHCTemplate.Form.ValuesT,
  SCHCTemplate.Form.RuleT
> {
  input: SCHCTemplate.API.BodyT | null = null;

  output: SCHCTemplate.Form.ValuesT | null = null;

  constructor(input: SCHCTemplate.API.BodyT) {
    this.input = input;
    this.generate();
  }

  generate = () => {
    this.output = {
      name: this.input?.name as string,
      sCHCTemplateID: +(this.input?.sCHCTemplateID as string),
      nonMatchingRule: this.input?.nonMatchingRule as number,
      unruly: this.input?.unruly as boolean,
      legacy: this.input?.legacy as boolean,
      description: this.input?.description as string,
      rules: this.rules() as any,
      createdBy: this.input?.createdBy,
      payloadPattern: this.input?.payloadPattern as any,
    };
  }

  private compression = (
    compressionRule: SCHCTemplate.API.Compression.RuleT,
  ): SCHCTemplate.Form.RuleT => ({
    ruleType: SCHCTemplate.COMPRESSION_RULE,
    ruleId: `${compressionRule.ruleId}`,
    stack: compressionRule.stack.stackType,
    fields: compressionRule.flows[0].ruleEntries.map((ruleEntry) => {
      const isDisplayedInForm = SCHCTemplateRuleEntryValidFieldNames
        .includes(ruleEntry.fieldName);
      /*
        Fields visible and editable :
        targetValue[0] will be stored in value (text field in form)
        > We are using field.value because it is easier
          to manipulate a string than an Array<string>
      */
      let value: string | undefined;
      if (isDisplayedInForm) {
        [value] = ruleEntry.targetValue;
      }
      return {
        ...ruleEntry,
        value,
      } as SCHCTemplate.Form.CompressionItem;
    }),
  });

  private fragmentation = (
    fragmentationRule: SCHCTemplate.API.Fragmentation.RuleT,
  ): SCHCTemplate.Form.RuleT => ({
    ruleType: SCHCTemplate.FRAGMENTATION_RULE,
    ruleId: `${fragmentationRule.ruleId}`,
    fragmentation: {
      ...fragmentationRule.fragmentationParam,
      direction: fragmentationRule.direction as string,
      disableAll1Payload: fragmentationRule
        .fragmentationParam.aoeSpecs?.disableAll1Payload as boolean,
      sendAckEveryWindow: fragmentationRule
        .fragmentationParam.aoeSpecs?.sendAckEveryWindow as boolean,
      enableImplicitAck: fragmentationRule
        .fragmentationParam.optaoeSpecs?.enableImplicitAck as boolean,
      optSendAckEveryWindow: fragmentationRule
        .fragmentationParam.optaoeSpecs?.sendAckEveryWindow as boolean,
    },
  })

  rules = (): Array<SCHCTemplate.Form.RuleT> => (this.input as SCHCTemplate.API.BodyT)
    .deviceSchcRules!
    .map((rule) => {
      if (rule.ruleType === SCHCTemplate.COMPRESSION_RULE) {
        return this.compression(rule.compressionRule as SCHCTemplate.API.Compression.RuleT);
      }
      return this.fragmentation(rule.fragmentationRule as SCHCTemplate.API.Fragmentation.RuleT);
    });

  get generatedForm(): SCHCTemplate.Form.ValuesT | null {
    return this.output;
  }
}

export default SCHCTemplateFormatAPIToForm;
